export default __webpack_public_path__ + "static/media/logout.5cc5ea62.svg";